import { NgModule }       from '@angular/core';
import { BrowserModule  } from '@angular/platform-browser';
import { Http } from  "@angular/http"
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { HttpModule } from '@angular/http';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { useLogMonitor } from '@ngrx/store-log-monitor';
import { EffectsModule } from '@ngrx/effects';

import { PathLocationStrategy, LocationStrategy } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { APP_RESOLVER_PROVIDERS } from './app/resolver';
import { APP_PROVIDERS, MerchantUiComponent } from './app';
import { ROUTES } from './app/app.routes';
import reducer from './app/reducers';
import * as effects from './app/effects';
import { UiHelperModule } from './app/ui-helper';
import { MerchantModule } from './app/components/merchants/merchant.module';
import { SponsorModule } from './app/components/sponsors/sponsor.module';
import { OrderActions }  from './app/components/order-components/order.actions';


import * as c from './app/components';
import { ReactiveFormsModule } from "@angular/forms";
import { provideAuth, AuthHttp, AuthConfig } from 'angular2-jwt';
import { ShoppingcartModule } from './app/components/shopping-cart/shopping-cart.module'
import { VenueModule } from './app/components/venue-components/venue.module'
import { APP_BASE_HREF } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { ReportingModule } from "./app/components/reporting";
import { CheckoutComponentsModule } from "./app/components/checkout-components/checkout-components.module";


@NgModule({
	declarations: [
		c.EventListComponent,
		c.EventFormComponent,
		c.EventTickets,
		c.EventsOnSaleComponent,
		c.NavigationComponent,
		c.MerchantUiComponent,
		c.CategoriesComponent,
		c.TicketQuotaCollection,
		c.EventWithVenue,
		c.TicketQuotas,
		c.BookingOfficesComponent,
		c.TicketCategories,
		c.TicketCategoriesBoxOffice,
		c.SpTicketCategoriesBoxOffice,
		c.VisualTickets,
		c.TicketQuotaTicketsInfo,
		c.EventWithVenueSearchBox,
		c.EventWithVenueList,
		c.MessagesComponent,
		c.TicketQuota,
		c.TicketQuotaForm,
		c.TicketQuotaMessageEditor,
		c.VisualTicketQuotaPresentation,
		c.HeaderComponent,
		c.ShoppingCartHeaderOverview,
		c.BoxOffice,
		c.EventStatusComponent,
		c.EventStatusPresentation,
		c.EventCurrentStatusComponent,
		c.EventCancelDialogComponent,
		c.EventCancelDialogPresentation,
		c.TicketDesignComponent,
		c.EventSeatingplanComponent,
		c.EventSeatingplanPresentation,
		c.DistributionChannelsComponent,
		c.DistributionChannelsPresentation,
		c.CostCenterComponent,
		c.CostCenterPresentation,
		c.ShipmentTypesComponent,
		c.ShipmentTypesPresentation,
		c.OnlineSaleComponent,
		c.OnlineSalePresentation,
		c.AdditionalChargesComponent,
		c.AdditionalChargesPresentation,
		c.SeasonEventsComponent,
		c.SeasonEventListSelectionComponent,
		c.SeasonEventListSelectionPresentation,
		c.OneTimeEventsComponent,
	],
	imports: [
		BrowserModule,
		RouterModule.forRoot(ROUTES),
		StoreModule.forRoot(reducer),
		EffectsModule.forRoot([
			effects.CategoryEffect,
			effects.CategoryFormEffect,
			effects.EventEffect,
			effects.MessageEffect,
			effects.PricelevelEffect,
			effects.ShoppingCartEffect,
			effects.TicketQuotaEffect,
			effects.TicketDesignEffects,
			effects.AdditionalChargeEffect,
			effects.TicketAddressEffect,
			effects.BoxOfficeEffect
		]),
		HttpModule,
		UiHelperModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyA-DKNAv4doSzMuQ6vVZE8qxIeFEuKn3PI'
		}),
		ReactiveFormsModule,
		ShoppingcartModule,
		ReportingModule,
		MerchantModule,
		SponsorModule,
		StoreDevtoolsModule.instrument({ // ReduxDevTools StoreLog-Integration
			maxAge: 25 //  Retains last 25 states
		}),
		CheckoutComponentsModule,
	],
	bootstrap: [MerchantUiComponent],
	providers: [
		{provide: LOCALE_ID, useValue: "de"},
		OrderActions,
		...APP_PROVIDERS,
		...APP_RESOLVER_PROVIDERS,
	// runEffects(effects),
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{provide: APP_BASE_HREF, useValue : LEO_APP_BASE_URL },
	]
})

export class AppModule {}



// WEBPACK FOOTER //
// ./src/app.module.ts